import type { ProfileTaskDraftReference, ProfileTaskSummary } from '../model/profile-task';

export type PersistedProfileTaskRemapping = {
    readonly canonicalTaskId: string;
    readonly canonicalTaskVersionId: string;
    readonly previousTaskId: string;
};

export const remapPersistedProfileTasks = (
    applied: readonly ProfileTaskDraftReference[],
    canonical: readonly ProfileTaskSummary[],
): readonly PersistedProfileTaskRemapping[] => {
    if (applied.length !== canonical.length) {
        return [];
    }

    return applied.flatMap((reference, index) => {
        const summary = canonical[index];
        return summary === undefined
            ? []
            : [
                  {
                      canonicalTaskId: summary.taskId,
                      canonicalTaskVersionId: summary.taskVersionId,
                      previousTaskId: reference.taskId,
                  },
              ];
    });
};
